export default __webpack_public_path__ + "images/451e17fbffca920f647b220ccae9ab82.svg";